import { writable } from 'svelte/store';
import uuid from 'uuid-browser/v4';

let interval;

export const notifications = writable([]);

export const ICONS = {
  LOADING: '/static/icons/loading.svg',
  ERROR: '/static/icons/skull.svg',
  SUCCESS: '/static/icons/success.svg',
  CONFIRM: '/static/icons/question.svg'
};

export const TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  LOADING: 'loading'
};

export function addNotification(notification) {
  clearTimeout(interval);

  if (notification.time) {
    interval = setTimeout(() => {
      notifications.update(n => {
        return [];
      });
    }, notification.time);
  }

  notifications.update(n => {
    return [{ ...notification, id: uuid() }];
  });
}
